import React, { ElementType, FC } from 'react'

import { Avatar, AvatarSizes } from '@inno-ui/avatar'
import { MultiplyIcon } from '@inno-ui/icons'
import cn from 'classnames'

import styles from './SavedUser.module.scss'
import { SavedUserProps } from './SavedUser.types'

export const SavedUser: FC<SavedUserProps> = ({
  user,
  onClick,
  onRemove,
  size = 'medium'
}) => {
  // When a remove button is also rendered, the outer wrapper cannot be a
  // <button> (button-in-button is invalid HTML and produces a DOM-nesting
  // warning). Fall back to a div with role/tabIndex so it stays accessible.
  const Component: ElementType = onClick && !onRemove ? 'button' : 'div'
  const wrapperProps =
    Component === 'div' && onClick
      ? {
          role: 'button',
          tabIndex: 0,
          onKeyDown: (e: React.KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onClick()
            }
          }
        }
      : {}

  const handleRemoveClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onRemove?.()
  }

  const handleRemoveMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
  }

  return (
    <Component
      className={cn(styles.savedUser, {
        [styles.medium]: size === 'medium',
        [styles.big]: size === 'big'
      })}
      onClick={onClick}
      {...wrapperProps}
    >
      <div className={styles.avatar}>
        {onRemove && (
          <button
            type='button'
            className={styles.removeButton}
            onClick={handleRemoveClick}
            onMouseDown={handleRemoveMouseDown}
            aria-label={`Remove ${user.name}`}
          >
            <MultiplyIcon color='var(--primary-blue-light)' />
          </button>
        )}
        <Avatar url={user.avatar || undefined} size={AvatarSizes.Size120} />
      </div>
      <div className={styles.name}>{user.name}</div>
    </Component>
  )
}
